import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./tax_rounding_mode.js";
//#region src/tax_rounding_mode_helper.ts
var tax_rounding_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "round": return "Mathematical Rounding";
		case "ceil": return "Always Round Up";
		case "floor": return "Always Round Down";
	}
}
//#endregion
export { name, tax_rounding_mode_helper_exports };

//# sourceMappingURL=tax_rounding_mode_helper.js.map